import { useGetCurrentUser } from '@/modules/Users/queries';
import { PropsWithChildren } from 'react';
import LoadingPage from '../LoadingPage/LoadingPage';
import OrganizationProvider from '../OrganizationProvider/OrganizationProvider';

export function LoggedLayout({ children }: PropsWithChildren) {
  const { data: user, isLoading } = useGetCurrentUser();
  return isLoading ? (
    <LoadingPage />
  ) : (
    <OrganizationProvider userOrganizations={user?.organizations ?? []}>
      {children}
    </OrganizationProvider>
  );
}
